import { render, staticRenderFns } from "./SearchSelectedFilters.vue?vue&type=template&id=06b9e21d&scoped=true&"
import script from "./SearchSelectedFilters.vue?vue&type=script&lang=js&"
export * from "./SearchSelectedFilters.vue?vue&type=script&lang=js&"
import style0 from "./SearchSelectedFilters.vue?vue&type=style&index=0&id=06b9e21d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b9e21d",
  null
  
)

export default component.exports